import { ArrowRight, ArrowDownRight } from "lucide-react";
import { COMPANY, IMAGES } from "@/lib/constants";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative isolate overflow-hidden"
      style={{ background: "#0A1128", paddingTop: "78px" }}
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src={IMAGES.hero}
          alt="Executive boardroom skyline view"
          className="w-full h-full object-cover opacity-35"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(115deg, rgba(10,17,40,0.96) 0%, rgba(10,17,40,0.82) 45%, rgba(10,17,40,0.55) 100%)",
          }}
        />
      </div>
      <div className="ra-grain absolute inset-0 z-[1]" />

      {/* Decorative side rule */}
      <div className="absolute top-0 bottom-0 left-6 md:left-10 w-px bg-white/8 z-[2] hidden md:block" />

      <div className="relative z-10 max-w-[1320px] mx-auto px-6 md:px-10 lg:px-14 pt-20 md:pt-28 lg:pt-36 pb-24 md:pb-36">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-9 xl:col-span-8">
            <div className="ra-eyebrow on-dark mb-7" data-testid="hero-tagline">
              <span className="dot" />
              <span>{COMPANY.tagline}</span>
            </div>

            <h1
              data-testid="hero-headline"
              className="font-heading text-white text-4xl sm:text-5xl lg:text-[68px] xl:text-[76px] font-medium leading-[1.05] tracking-tight"
            >
              Strategic Advisory for{" "}
              <span className="text-white">Real Estate, Construction</span>{" "}
              <span className="text-[#00A859]">& Risk Management</span>
              <span className="text-[#00A859]">.</span>
            </h1>

            <p
              data-testid="hero-subheadline"
              className="font-body text-white/75 text-lg md:text-xl mt-8 max-w-3xl leading-relaxed"
            >
              Helping developers, investors, property owners, and construction
              professionals make informed decisions, reduce risk, and execute
              projects with confidence.
            </p>

            <p
              data-testid="hero-supporting"
              className="font-body text-white/55 text-base md:text-[15px] mt-6 max-w-2xl leading-relaxed"
            >
              Ramo Advisors LLC provides independent advisory services that
              help clients identify risk, evaluate opportunities, improve
              project outcomes, and protect investments throughout the
              lifecycle of a project.
            </p>

            <div className="mt-12 flex flex-wrap gap-4">
              <button
                data-testid="hero-primary-cta"
                onClick={() => scrollToId("contact")}
                className="ra-btn-primary"
              >
                Schedule a Consultation
                <ArrowRight size={16} />
              </button>
              <button
                data-testid="hero-secondary-cta"
                onClick={() => scrollToId("services")}
                className="ra-btn-secondary"
              >
                Explore Services
                <ArrowDownRight size={16} />
              </button>
            </div>
          </div>

          <div className="lg:col-span-3 xl:col-span-4 hidden lg:flex flex-col gap-8 items-end">
            <div className="text-right">
              <div className="font-heading text-[#00A859] text-5xl xl:text-6xl leading-none">
                01
              </div>
              <div className="font-body text-white/45 mt-3 text-[11px] tracking-[0.28em] uppercase">
                Independent Advisory
              </div>
            </div>
            <div className="w-full h-px bg-white/10" />
            <div className="text-right">
              <div className="font-heading text-white text-2xl xl:text-3xl leading-tight">
                NJ • NY
                <br />
                <span className="text-white/55">Nationwide</span>
              </div>
              <div className="font-body text-white/45 mt-3 text-[11px] tracking-[0.28em] uppercase">
                Service Coverage
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom hairline */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-white/8 z-[2]" />
    </section>
  );
};

export default Hero;
